export default "__VITE_ASSET__050070de__"